import React, { useState, useEffect, useContext } from "react";
import { Container, Row, Col, Card, Button, Form } from "react-bootstrap";
import {
  FaStar,
  FaStarHalfAlt,
  FaRegStar,
  FaMapMarkerAlt,
  FaCheckCircle,
  FaBox,
  FaSearch,
  FaFilter,
} from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import "../../../../assets/css/user/shoppage/shopslist/ShopsList.css";
import AppContext from "../../../../context/AppContext";
import axios from "axios";

const ShopsList = () => {
  const navigate = useNavigate();
  const { baseUrl, baseUrlForFile } = useContext(AppContext);
  const [shopsData, setShopsData] = useState([]);

  // All Shops Data
  const allShops = shopsData;

  // States
  const [searchQuery, setSearchQuery] = useState("");
  const [selectedLocation, setSelectedLocation] = useState("All");
  const [selectedRating, setSelectedRating] = useState("All");

  // Pagination states
  const [currentPage, setCurrentPage] = useState(1);
  const shopsPerPage = 2; // 1 page par kitni shops dikhani hain

  const fetchAllShops = () => {
    axios
      .get(`${baseUrl}/customer/shops/fetchAllShops`)
      .then((res) => {
        console.log(res.data);
        if (res.data.success == true) {
          setShopsData(res.data.shops);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };

  useEffect(() => {
    console.log("log from the shop data");
    fetchAllShops();
  }, []);

  // Get unique locations
  const locations = [
    "All",
    ...new Set(allShops.map((shop) => shop.address?.trim()).filter(Boolean)),
  ];

  // Filter shops
  const filteredShops = allShops.filter((shop) => {
    const searchMatch =
      (shop.businessname || "")
        .toLowerCase()
        .includes(searchQuery.toLowerCase()) ||
      (shop.address || "").toLowerCase().includes(searchQuery.toLowerCase());

    const locationMatch =
      selectedLocation === "All" ||
      (shop.address || "").trim().toLowerCase() ===
        selectedLocation.trim().toLowerCase();

    const ratingMatch =
      selectedRating === "All" ||
      (selectedRating === "4+" && Number(shop.rating) >= 4) ||
      (selectedRating === "4.5+" && Number(shop.rating) >= 4.5);

    return searchMatch && locationMatch && ratingMatch;
  });

  // Get current page shops
  const indexOfLastShop = currentPage * shopsPerPage;
  const indexOfFirstShop = indexOfLastShop - shopsPerPage;
  const currentShops = filteredShops.slice(indexOfFirstShop, indexOfLastShop);

  // Total pages
  const totalPages = Math.ceil(filteredShops.length / shopsPerPage);

  // Render stars
  const renderStars = (rating) => {
    const stars = [];
    const fullStars = Math.floor(rating);
    const hasHalfStar = rating % 1 !== 0;

    for (let i = 0; i < fullStars; i++) {
      stars.push(<FaStar key={`full-${i}`} className="star-icon filled" />);
    }
    if (hasHalfStar) {
      stars.push(<FaStarHalfAlt key="half" className="star-icon filled" />);
    }
    const emptyStars = 5 - Math.ceil(rating);
    for (let i = 0; i < emptyStars; i++) {
      stars.push(<FaRegStar key={`empty-${i}`} className="star-icon" />);
    }
    return stars;
  };

  // Reset filters
  const resetFilters = () => {
    setSearchQuery("");
    setSelectedLocation("All");
    setSelectedRating("All");
  };

  return (
    <div className="shops-listing-page">
      <Container>
        {/* Search & Filters Section */}
        <div className="search-filters-section">
          <Row className="align-items-end  ">
            <Col lg={4} md={6} className="mb-3">
              <div className="search-box">
                <FaSearch className="search-icon" />
                <Form.Control
                  type="text"
                  placeholder="Search shops by name or location..."
                  value={searchQuery}
                  onChange={(e) => setSearchQuery(e.target.value)}
                  className="search-input"
                />
              </div>
            </Col>

            <Col lg={2} md={6} sm={6} className="mb-3">
              <Form.Label className="filter-label">Location</Form.Label>
              <Form.Select
                value={selectedLocation}
                onChange={(e) => setSelectedLocation(e.target.value)}
                className="filter-select"
              >
                {locations.map((loc) => (
                  <option key={loc} value={loc}>
                    {loc}
                  </option>
                ))}
              </Form.Select>
            </Col>

            <Col lg={2} md={6} sm={6} className="mb-3">
              <Form.Label className="filter-label">Rating</Form.Label>
              <Form.Select
                value={selectedRating}
                onChange={(e) => setSelectedRating(e.target.value)}
                className="filter-select"
              >
                <option value="All">All Ratings</option>
                <option value="4.5+">4.5+ Stars</option>
                <option value="4+">4+ Stars</option>
              </Form.Select>
            </Col>

            <Col lg={2} md={12} className="mb-3">
              <Button onClick={resetFilters} className="reset-filters-btn">
                Reset Filters
              </Button>
            </Col>
          </Row>
        </div>

        {/* Results Count */}
        <div className="results-info">
          Showing {filteredShops.length}{" "}
          {filteredShops.length === 1 ? "shop" : "shops"}
        </div>

        {/* Shops Grid */}
        <Row>
          {currentShops.map((shop) => (
            <Col key={shop.id} lg={12} className="mb-4">
              <Card className="shop-card">
                <Row className="g-0">
                  {/* Shop Banner & Logo */}
                  <Col md={4}>
                    <div className="shop-image-section">
                      <div
                        className="shop-banner-img"
                        style={{
                          backgroundImage: `url(${baseUrlForFile}/${shop.logo})`,
                        }}
                      >
                        <div className="banner-overlay"></div>
                      </div>
                    </div>
                  </Col>

                  {/* Shop Info */}
                  <Col md={5}>
                    <Card.Body className="shop-info-body">
                      <div className="shop-header">
                        <h3 className="shop-name">
                          {shop.businessname}
                          {shop.verified && (
                            <FaCheckCircle
                              className="verified-icon"
                              title="Verified"
                            />
                          )}
                        </h3>
                      </div>

                      <div className="shop-rating">
                        <div className="stars-display">
                          {renderStars(shop.rating)}
                        </div>
                        <span className="rating-text">
                          <strong>{shop.rating}</strong>
                        </span>
                      </div>

                      <p className="shop-description">{shop.description}</p>

                      {/* Featured Products Preview */}
                      <div className="featured-products">
                        <small className="featured-label">
                          Featured Equipment:
                        </small>

                        <div className="featured-images">
                          {shop.srrentaladmin?.srequipmentmanagments?.length >
                          0 ? (
                            shop.srrentaladmin.srequipmentmanagments
                              .slice(0, 3)
                              .map((product) => (
                                <div
                                  key={product.id}
                                  className="featured-item"
                                  title={product.equipmentname}
                                >
                                  <img
                                    src={`${baseUrlForFile}/${product.image}`}
                                    alt={product.equipmentname}
                                  />
                                </div>
                              ))
                          ) : (
                            <p>No featured products</p>
                          )}
                        </div>
                      </div>
                    </Card.Body>
                  </Col>

                  {/* Action Section */}
                  <Col md={3}>
                    <div className="shop-action-section">
                      {/* Visit Button */}
                      <Button
                        className="list-visit-shop-btn"
                        onClick={() => navigate(`/shop/${shop.id}`)}
                      >
                        Visit Shop
                      </Button>

                      {/* Location */}
                      <div className="shop-action-info">
                        <div className="meta-item">
                          <FaMapMarkerAlt className="meta-icon" />
                          <span>{shop.address}</span>
                        </div>
                      </div>

                      {/* Products + Rating */}
                      <div className="quick-stats">
                        <div className="stat-item">
                          <span className="stat-number">
                            {shop.totalProducts}+
                          </span>
                          <span className="stat-label">Products</span>
                        </div>

                        <div className="stat-item">
                          <span className="stat-number">{shop.rating}</span>
                          <span className="stat-label">Rating</span>
                        </div>
                      </div>
                    </div>
                  </Col>
                </Row>
              </Card>
            </Col>
          ))}
        </Row>

        {/* No Results Message */}
        {filteredShops.length === 0 && (
          <div className="no-results">
            <FaFilter className="no-results-icon" />
            <h3>No Shops Found</h3>
            <p>Try adjusting your search or filters</p>
            <Button onClick={resetFilters} className="reset-btn-large">
              Reset All Filters
            </Button>
          </div>
        )}

        {/* Pagination */}
        {totalPages > 1 && (
          <div className="pagination-container">
            <Button
              disabled={currentPage === 1}
              onClick={() => setCurrentPage((prev) => prev - 1)}
              className="pagination-btn"
            >
              Prev
            </Button>

            {Array.from({ length: totalPages }, (_, i) => (
              <Button
                key={i + 1}
                className={`pagination-btn ${currentPage === i + 1 ? "active" : ""}`}
                onClick={() => setCurrentPage(i + 1)}
              >
                {i + 1}
              </Button>
            ))}

            <Button
              disabled={currentPage === totalPages}
              onClick={() => setCurrentPage((prev) => prev + 1)}
              className="pagination-btn"
            >
              Next
            </Button>
          </div>
        )}
      </Container>
    </div>
  );
};

export default ShopsList;
